import {Directive, Input} from '@angular/core';
import {PredictionModelDto} from '@sharedrest/data.restservice';

@Directive({selector: '[variableValueVariableValue]'})
export class VariableValueVariableValueDirective {
  @Input() variableValueVariableValue: any;
  @Input() entity: PredictionModelDto;
}
